module.exports = __webpack_public_path__ + "static/img/comment.09e98588.png";